import { blue, brand, common, gray, green, orange, purple, red } from "./colors";
import { defaultThemeMode, isSupportedThemeMode } from "./modes";

export function createPalette(mode = defaultThemeMode) {
  const resolvedMode = isSupportedThemeMode(mode) ? mode : defaultThemeMode;
  const focusRing = "rgba(129, 66, 252, 0.18)";
  const errorRing = "rgba(239, 68, 68, 0.18)";

  return {
    mode: resolvedMode,
    primary: {
      light: purple[300],
      main: purple[500],
      dark: purple[700],
      contrastText: common.white,
    },
    secondary: {
      light: purple[100],
      main: purple[600],
      dark: purple[800],
      contrastText: common.white,
    },
    success: {
      light: green[100],
      main: green[500],
      dark: green[800],
      contrastText: common.white,
    },
    warning: {
      light: orange[100],
      main: orange[500],
      dark: orange[700],
      contrastText: gray[900],
    },
    error: {
      light: red[100],
      main: red[500],
      dark: red[800],
      contrastText: common.white,
    },
    info: {
      light: purple[100],
      main: purple[500],
      dark: purple[700],
      contrastText: common.white,
    },
    grey: gray,
    divider: "rgba(82, 82, 91, 0.18)",
    background: {
      default: gray[50],
      paper: common.white,
    },
    text: {
      primary: gray[900],
      secondary: gray[600],
      disabled: gray[400],
    },
    action: {
      hover: "rgba(129, 66, 252, 0.06)",
      selected: "rgba(129, 66, 252, 0.12)",
      disabled: gray[400],
      disabledBackground: gray[100],
    },
    surface: {
      default: common.white,
      muted: gray[50],
      subtle: gray[100],
      inverse: gray[900],
    },
    border: {
      default: gray[200],
      muted: gray[100],
      strong: gray[300],
      focus: purple[500],
      error: red[500],
    },
    feedback: {
      success: {
        surface: green[50],
        border: green[200],
        text: green[700],
        accent: green[500],
      },
      warning: {
        surface: orange[50],
        border: orange[200],
        text: orange[700],
        accent: orange[500],
      },
      error: {
        surface: red[50],
        border: red[200],
        text: red[700],
        accent: red[500],
      },
      info: {
        surface: purple[50],
        border: purple[200],
        text: purple[700],
        accent: purple[500],
      },
      neutral: {
        surface: gray[50],
        border: gray[200],
        text: gray[700],
        accent: gray[500],
      },
    },
    focusRing,
    errorRing,
    custom: {
      gray,
      brand,
      common,
      blue,
      green,
      orange,
      red,
      purple,
    },
  };
}

export const palette = createPalette(defaultThemeMode);
